<!--盘点单镜架-->
<template>
  <div>
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="仓库" :label-width="formLabelWidth" prop="cangkucode" size="small"
                        style="text-align: left;">
            <el-select v-model="form.cangkuname" placeholder="请选择" @change="changename"
                       :required="true" v-if="btnvisible">
              <el-option
                v-for="item in jxcstoreDataf"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item">
              </el-option>
            </el-select>
            <span v-else>{{form.cangkuname}}&nbsp;&nbsp;<br>{{form.accdate}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品分类" :label-width="formLabelWidth" prop="seedname" size="small"
                        style="text-align: left;">
            <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData" :isShowCheckBox="false"
                        v-model="form.seedname" :treeWidth="340" v-if="btnvisible"
                        :treeHeight="350" :searchText="form.seedname" :onlySelectChild="onlySelectChild" :canSelectGroupTypeNode="!onlySelectChild"
                        @check="checktree1"></CommonTree>
            <span v-else>{{form.seedname}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <span v-if="btnvisible">{{pingpainame}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="false">
        <el-col :span="10">
          <el-form-item label="盘点日期" :label-width="formLabelWidth" prop="accdate">
            <el-input v-model="form.accdate" auto-complete="off" :required="true" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="24">
          <div style="float: left;width: 250px;padding-left:10px" v-if="btnvisible||form.needaudit == 1">
            {{subinfo}}
          </div>
          <div style="float: right;width: 300px" v-if="btnvisible">
            <el-button type="success" v-on:click="addFrame" v-if="btnvisible" size="mini">增 加</el-button>
            <el-button type="warning" size="mini" @click="exportExceltable" v-if="form.seedcode">导出</el-button>
            <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
            <el-button type="warning" v-on:click="jingjiaupload" v-if="btnvisible&&!enabledaddgoods" size="mini">导入</el-button>
            &nbsp;&nbsp;<a href="./static/file/镜架导入模板.xlsx" v-if="btnvisible">模板</a>
          </div>
          <div style="float: right;padding-right: 100px" v-if="form.needaudit == 1&&extendForm.storenumbers">
            <el-button type="success" @click="showChangepdd" v-if="!onauditchange">修改盘点单</el-button>
            <el-button type="primary" @click="saveChangepdd" v-if="onauditchange">保存修改</el-button>
            <el-button type="info" @click="onauditchange=false" v-if="onauditchange">取消修改</el-button>
          </div>
          <div style="float: right;width: 300px;padding-right:30px">
            <el-input style="width: 120px" ref="searchmodelRef" v-model="searchmodel" auto-complete="off" placeholder="搜索型号" size="mini"  onfocus="this.select()"></el-input>
            <el-input style="width: 150px" size="mini" v-model="goodsbarcode" v-if="btnvisible" @change="getBarCode()" placeholder="扫唯一码" onfocus="this.select()"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="24">
          <el-form-item label="备注：" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="1" v-if="btnvisible||onauditchange"
              v-model="form.remark">
            </el-input>
            <div v-else>{{form.remark}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="24">
          <el-table
            ref="singleTable"
            :data="storetable.filter(data => !searchmodel || data.M.toLowerCase().includes(searchmodel.toLowerCase())|| data.seedname.toLowerCase().includes(searchmodel.toLowerCase()))"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column width="50"  type="index" :index="indexMethod"  label="序" align="center">
            </el-table-column>
            <el-table-column
              prop="seedname"
              label="商品名称" :show-overflow-tooltip="true"
              align="left" width="200"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="seedcode"
              label="编码" :show-overflow-tooltip="true"
              align="left"
              header-align="center"
              width="50">
            </el-table-column>
            <el-table-column
              prop="M"
              label="型号"
              align="left" :show-overflow-tooltip="true"
              header-align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="C"
              label="色号"
              align="left" :show-overflow-tooltip="true"
              header-align="center"
              width="70">
            </el-table-column>
            <el-table-column
              prop="costprice"
              label="零售价"
              align="left" :show-overflow-tooltip="true"
              header-align="center"
              width="70">
            </el-table-column>
            <el-table-column
              prop="subtractnum"
              label="库存数"
              align="left"
              header-align="center" v-if="btnvisible||showKucun||onauditchange"
              width="70">
            </el-table-column>
            <el-table-column
              prop="deliverying"
              label="待出库"
              align="left"
              header-align="center" v-if="btnvisible||showKucun||onauditchange"
              width="70">
              <template slot-scope="scope">
                <span> {{scope.row.deliverying>0?scope.row.deliverying:''}}</span>
              </template>
            </el-table-column>
            <el-table-column
            prop="tractnum"
            label="可用数"
            align="left"
            header-align="center" v-if="btnvisible||showKucun||onauditchange"
            width="70">
            </el-table-column>
            <el-table-column
              prop="P"
              label="盘点数"
              align="left"
              width="100"
              header-align="center">
              <template slot-scope="scope">
                <el-input-number :ref='scope.row.id' v-model="scope.row.P" :controls="false" @change="subData" @focus="focus($event)" size="mini" style="width: 90px" v-if="btnvisible||onauditchange"></el-input-number>
                <span v-else>{{scope.row.P}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="差异数"
              align="center"
              header-align="center" v-if="btnvisible||showKucun||onauditchange"
              width="70">
              <template slot-scope="scope">
                <span> {{calNum(scope.row)}}</span>
              </template>
            </el-table-column>
          </el-table></el-col></el-row>
      <el-row :gutter="20">

    </el-row>
    </el-form>
    <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelect"></MakeInventoryFrameAdd>
    <!--<div slot="footer" class="dialog-footer">-->
      <!--<el-button @click="close()">取 消</el-button>-->
      <!--<el-button type="warning" @click="toZero(false)" plain v-if="btnvisible">清零</el-button>-->
      <!--<el-button type="warning" @click="toFormat(false)" plain v-if="btnvisible">默认库存</el-button>-->
      <!--<el-button type="primary" @click="saveData" v-if="btnvisible" :loading="loading">保 存</el-button>-->
    <!--</div>-->
  </div>
</template>

<script>
  import {getGoodsTree,listgoodsframe,jingjiaupload} from '@/api/set/jxcgooddetail';
  import {getControlData} from '@/api/set/goodsprice';
  import {inventorySave} from '@/api/set/jxcstoreform';
  import {isUGO,isXiaoTuan,isDatao} from '@/api/login';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {loadSpecFrame} from '@/plugin/ordercommon'
  import MakeInventoryFrameAdd from './MakeInventoryFrameAdd';
  import {getDetail as barcodeDetail} from '@/api/set/jxcstoregoodsbarcode';
  import {formatTimeToStr} from '@/plugin/Date';

  export default {
    name: 'MakeInventoryFrameEdit',
    msg: '盘点单',
    data() {
      return {
        enabledaddgoods:false,
        onlySelectChild:true,
        addvisible: true,
        showKucun:false,
        loading:false,
        guids: '',//商品编码
        goodstable: [],//所有商品列表
        storetable: [],
        searchmodel:'',
        subinfo:'',
        pingpainame:'',
        onauditchange:false,
        goodsbarcode:'',
        selectgoodsbarcode:'',
        form: {  //表单数据
          accdate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          cangkucode: '',
          cangkuname: '',
          packagesizes: '',
          seedcode: '',
          seedname: '',
          status: 10,
          formtype: 74,
          filltemplate: '80',
          auditcontent:'',
          remark: '',
          totalnumber: 0,
          physicalstore:'',
          unitguid:'',
          changeunitguid:'',
          physicalstorecode:''
        },
        extendForm:{
          storenumbers:null,
          yinxincert:null,
        },
        packagesizes: [],//存储盘点数据
        formLabelWidth: '120px',
        btnvisible: true,//控制确定按钮显示、隐藏
        rules: {////////定义正则验证字段。
          cangkucode: [
            {required: true, message: '请选择仓库', trigger: 'blur'},
          ],
          seedname: [
            {required: true, message: '请选择货品', trigger: 'change'},
          ],
        },
      }
    },
    props:{
      jxcstoreDataf:[]
    },
    methods: {
      close() {
        this.$emit('close');
      },
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      exportExceltable() {
        let header1 = ["商品编码", "商品名称", "型号", "色号", "零售价", "库存数","待出库","可用数","盘点数"];
        let column1 = ["seedcode", "seedname", "M", "C", "costprice", "subtractnum","deliverying","tractnum","P"];

        var name = this.pingpainame + (this.form.seedname == this.pingpainame ? '' : this.form.seedname);
        var biaoti = []
        // biaoti.push(formatTimeToStr(new Date()))
        // biaoti.push("")
        // biaoti.push("")
        // biaoti.push(name)

        var data = [];
        var totalN = 0;
        for (let i in this.storetable) {
          totalN += this.storetable[i].tractnum;
          data.push(this.storetable[i])
        }
        // data.push({seedname:'合计',tractnum:totalN});

        name = name + formatTimeToStr(new Date());
        this.$exportExcel(header1, column1, data, name, biaoti)
      },
      getBarCode() {
        if (this.form.cangkucode && this.form.seedcode && this.form.seedcode.length >= 9) {

        } else {
          this.$message({
            message: '请先选择仓库以及商品系列！',
            type: 'warning'
          });
          this.goodsbarcode = '';
          return;
        }

        if (this.goodsbarcode == '')
          return;
        if (this.selectgoodsbarcode == '')
          this.selectgoodsbarcode = ';';

        if (this.selectgoodsbarcode.indexOf(';' + this.goodsbarcode + ';') > -1) {
          this.error('重复扫码！')
          this.goodsbarcode = '';
          return;
        }
        barcodeDetail({storegoodsbarcode: this.goodsbarcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;
            if (arr.packagesize.indexOf('"M"') == -1) {
              this.error('非镜架商品！')
              this.goodsbarcode = '';
              return;
            }

            var barcode = this.goodsbarcode;
            this.selectgoodsbarcode += this.goodsbarcode + ';';
            this.goodsbarcode = '';
            var pg = JSON.parse(arr.packagesize);
            var good = null;
            for (let i in this.goodstable) {
              if (this.goodstable[i].seedcode == arr.seedcode) {//有对应的产品
                if (pg.C) {
                  if (this.goodstable[i].model == pg.M && (';' + this.goodstable[i].color + ';').indexOf(';' + pg.C + ';') > -1) {
                    good = this.goodstable[i];
                    break;
                  }
                } else {//没有填
                  if (this.goodstable[i].model == pg.M && this.goodstable[i].color == '') {
                    good = this.goodstable[i];
                    break;
                  }
                }
              }
            }
            if (good)
              this.afterSelect([{seedcode: good.seedcode, seedname: good.seedname, M: pg.M, C: pg.C, P: 1}]);
            else {
              this.error('非本系列商品！')
              this.goodsbarcode = '';
              return;
            }
          } else {
            this.goodsbarcode = '';
            this.error('产品编码不存在！')
          }
        });
      },
      //给scancodes 添加 id，共回车使用
      indexMethod(index) {
        this.storetable[index].id = index
        return index + 1;
      },
      addFrame() {
        if (this.form.cangkucode && this.form.seedcode && this.form.seedcode.length >= 6) {
          this.$refs.MakeInventoryFrameAdd.show(this.goodstable)
        } else {
          this.$message({
            message: '请先选择仓库以及商品系列！',
            type: 'warning'
          });
        }
      },
      focus(event) {
        event.currentTarget.select();
      },
      toFormat() {
        for (let i in this.storetable) {
          this.storetable[i].P = this.storetable[i].tractnum
        }
        this.subData();
      },
      toZero() {
        for (let i in this.storetable) {
          this.storetable[i].P = 0
        }
        this.subData();
      },
      calNum(row) {
        if (!row.tractnum)
          row.tractnum = 0;
        if (!row.P)
          row.P = 0;
        if (row.P == row.tractnum)
          return '';
        return row.P - row.tractnum;
      },
      show(cangkucode) {
        this.initForm();
        this.changename({cangkucode: cangkucode});
      },
      jingjiaupload() {
        if (this.form.cangkucode && this.form.seedcode && this.form.seedcode.length >= 9) {
          this.$refs.fileupload.value = ""
          this.$refs.fileupload.click()
        } else {
          this.$message({
            message: '请先选择仓库以及商品系列！',
            type: 'warning'
          });
        }
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
              var catename = this.pingpainame + this.form.seedname.replace(this.pingpainame, '')
              let arr = loadSpecFrame(data, this.form.seedcode, catename);
              if (arr.length > 0) {
                for (var i in arr) {

                  var MandC = JSON.parse(arr[i].goodsframe)[0];
                  var hasValue = false;
                  for (var j in this.storetable) {
                    if (MandC.model == this.storetable[j].M && MandC.color == this.storetable[j].C) {//在库存里的
                      arr[i].seedcode = this.storetable[j].seedcode;
                      this.storetable[j].excelitem = arr[i];
                      this.storetable[j].P = arr[i].minnumber;
                      hasValue = true
                      break;
                    }
                  }
                  if (!hasValue) {
                    var item = {
                      "seedcode": "",
                      "seedname": arr[i].seedname,
                      "tractnum": 0,//当前库存数量
                      "M": MandC.model,
                      "C": MandC.color,
                      "excelitem": arr[i],
                      "P": arr[i].minnumber//盘点数量
                    };

                    for (var m in this.goodstable) {
                      if (this.goodstable[m].model == MandC.model) {
                        item.seedcode = this.goodstable[m].seedcode;
                        item.seedname = this.goodstable[m].seedname;
                        break;
                      }
                    }
                    this.storetable.push(item);
                  }
                }
                this.sortTable();
              }
            }
          )
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      afterSelect(arr) {
        var needsort = false;
        for (var i in arr) {
          var MandC = arr[i];
          var hasValue = false;
          for (var j in this.storetable) {
            if (MandC.M == this.storetable[j].M && MandC.C == this.storetable[j].C) {//在库存里的
              this.storetable[j].excelitem = null;
              if (this.storetable[j].P == '' || this.storetable[j].P == null)
                this.storetable[j].P = 0;
              this.storetable[j].P += MandC.P;
              hasValue = true
              break;
            }
          }
          if (!hasValue) {
            var item = {
              "seedcode": MandC.seedcode,
              "seedname": MandC.seedname,
              "tractnum": 0,//当前库存数量
              "M": MandC.M,
              "C": MandC.C,
              "excelitem": null,
              "P": MandC.P//盘点数量
            };
            needsort = true;
            this.storetable.push(item);
          }
        }
        if (needsort)
          this.sortTable();
        else {
          this.subData();
        }
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (!valid)
            return;

          this.loading = true
          //一个二维表,过滤数量为空和0
          //10现片，20定制片，30区分左右眼
          //存储二维表过滤后的数据
          var seedarr = [];
          for (let i in this.storetable) {
            if (this.storetable[i].P && parseInt(this.storetable[i].P) > 0) {//有盘点数量的
              if (this.storetable[i].excelitem && this.storetable[i].excelitem.goodsframe)
                seedarr.push(this.storetable[i].excelitem)
            }
          }
          if(this.enabledaddgoods){
            seedarr=[];//小团 和 优购不允许增加新的商品
          }

          //先补录产品
          jingjiaupload({arr: JSON.stringify(seedarr)}).then(response => {
            if (response.data.code == 0) {
              var returnSeed = response.data.obj;
              if (returnSeed == null) returnSeed = [];

              var arr = [];
              for (let i in this.storetable) {
                var CY = (this.storetable[i].P ? parseInt(this.storetable[i].P) : 0) - (this.storetable[i].tractnum ? parseInt(this.storetable[i].tractnum) : 0);
                if (CY != 0) {//有差异数量的
                  //补商品编码
                  if (this.storetable[i].seedcode == '' && this.storetable[i].excelitem && this.storetable[i].excelitem.goodsframe) {
                    for (let j in returnSeed) {
                      if (returnSeed[j].goodsframe == this.storetable[i].excelitem.goodsframe) {
                        this.storetable[i].seedcode = returnSeed[j].seedcode
                        this.storetable[i].seedname = returnSeed[j].seedname
                        break;
                      }
                    }
                  }
                  //this.storetable[i].excelitem = '';
                  arr.push({
                    "seedcode": this.storetable[i].seedcode,
                    "seedname": this.storetable[i].seedname,
                    "M": this.storetable[i].M,
                    "C": this.storetable[i].C,
                    "P": CY
                  });
                }
              }
              this.form.auditcontent=this.subinfo;
              for (let i in arr) {
                if (arr[i].seedcode == '') {
                  this.$message({
                    message: '商品不存在！',
                    type: 'warning'
                  })
                  this.loading = false
                  this.form.changeunitguid=''
                  return
                }
              }

              this.form.packagesizes = JSON.stringify(arr);

              this.form.physicalstore = this.pingpainame + this.form.seedname.replace(this.pingpainame, '');
              this.form.physicalstorecode = this.form.seedcode;
              if(this.form.accdate){
                var accD=new Date(this.form.accdate);
                this.form.accdate=accD.getFullYear() + '-' + (accD.getMonth() + 1) + '-' + accD.getDate();
              }
              inventorySave(this.form).then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  //刷新列表
                  this.$emit('bindGrid');
                  if (this.form.changeunitguid) {
                    this.onauditchange = false;
                  } else {
                    this.close();
                  }
                } else {
                  this.$message({message: response.data.msg, type: 'error'});
                }
                this.form.changeunitguid=''
                this.loading = false
              });
            } else {
              this.$message({
                type: 'error',
                message: response.data.msg
              });
              this.form.changeunitguid=''
              this.loading = false
            }
          })
        })
      },
      initData(response) {
        this.initForm()
        this.btnvisible = false
        this.showKucun = true;

        this.extendForm.storenumbers=response.data.obj.storenumbers;
        this.form.cangkucode = response.data.obj.cangkucode
        this.form.cangkuname = response.data.obj.cangkuname
        this.form.seedname = response.data.obj.seedname;
        this.form.seedcode = response.data.obj.seedcode;
        this.form.unitguid = response.data.obj.unitguid;
        this.form.remark = response.data.obj.remark;
        this.form.accdate = response.data.obj.accdate;

        if (response.data.obj.packagesizes) {
          this.storetable = JSON.parse(response.data.obj.packagesizes)
          if (response.data.obj.needaudit == 1||this.extendForm.storenumbers) {
            this.form.needaudit=response.data.obj.needaudit;
            this.checktree1(this.form.seedcode, this.form.seedname);
          } else {
            this.showKucun = false;
            this.sortTable();
          }
        }

      },
      showChangepdd() {
        this.onauditchange = true;
      },
      saveChangepdd(){
        this.form.changeunitguid = this.form.unitguid;
        this.saveData();
      },
      //初始化
      initForm() {
        this.goodstable = []
        this.selectgoodsbarcode = ''
        this.storetable = []
        this.onauditchange=false;
        this.form.seedcode = ""
        this.extendForm.storenumbers=null;
        this.form.seedname = ""
        this.form.remark = ''
        this.form.totalnumber = 0
        this.form.cangkucode = ''
        this.form.cangkuname = ''
        this.form.unitguid='';
        this.form.changeunitguid='';
        this.form.accdate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();
        this.loading = false
        this.btnvisible = true;
        this.form.enabled = 1

        this.form.needaudit=''
        this.showKucun = false;
        this.index = ''
        if (this.$refs.treedept != undefined) {
          this.$refs.treedept.reset();
        }
        this.subData();

      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true, categorystarts: '002;003;005;004'})
        })
      },
      //选择商品树所执行的方法
      checktree1(guids, names, arr) {
        if (!guids || guids.length == 3) {
          if(this.form.seedcode){
            this.$refs.treeSeed.setText(this.form.seedname);
          }
          return;
        }

        this.form.seedcode = guids//分类编码
        this.form.seedname = names//商品名称
        this.pingpainame = this.$refs.treeSeed && this.form.seedcode.length == 12 ? (this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label) : '';
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择分类',
            type: 'warning'
          })
          return
        }
        this.getXYRange();
      },
      //二维表展示范围
      getXYRange() {
        //获取商品分类下的所有商品
        listgoodsframe({categorycode: this.form.seedcode, filltemplate: '80'}).then((response) => {
          //所有镜架商品
          this.goodstable = response.data.obj;

          if (this.form.cangkucode) {
            if (this.btnvisible || this.showKucun) {
              this.createPriceBook()
            }
          }
        })
      },
      changename(val) {
        this.form.cangkucode = val.cangkucode;
        for (let i in this.jxcstoreDataf) {
          if (this.jxcstoreDataf[i].cangkucode == val.cangkucode) {
            this.form.cangkuname = this.jxcstoreDataf[i].cangkuname;
            break;
          }
        }
        if (this.form.seedcode)
          this.createPriceBook()
      },
      subData() {
        var tSub = 0
        var pSub = 0;
        var cSub = 0;
        for (let i in this.storetable) {
          var cn = this.calNum(this.storetable[i]);
          if (cn)
            cSub += cn;
          tSub += parseInt(this.storetable[i].tractnum);
          pSub += parseInt(this.storetable[i].P);
        }
        this.subinfo = '盘点：' + pSub + ' 、库存：' + tSub + ' 、' + (cSub == 0 ? '无差异！' : ((cSub > 0 ? '盘盈：' : '盘亏：') + cSub));
      },
      sortTable() {
        this.storetable.sort(function (a, b) {
          if (a.seedname == b.seedname) {
            if (a.M == b.M)
              return a.C.localeCompare(b.C)
            else
              return a.M.localeCompare(b.M)
          } else
            return a.seedname.localeCompare(b.seedname)
        })
        this.subData();
      },
      createPriceBook() {
        if (this.extendForm.storenumbers!=null) {
          this.subinfo = this.form.auditcontent;
          var sn = this.extendForm.storenumbers;
          for (let i in sn) {
            sn[i].deliverying = sn[i].delin;
            sn[i].subtractnum = sn[i].closen;
            sn[i].seedcode = sn[i].SeedCode;
            sn[i].packagesize = sn[i].Packagesize;
          }
          this.initWithStoredetail(sn);
          return;
        }

        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1

        var seedcodes = ','
        for (let i in this.goodstable) {
          if (seedcodes.indexOf(',' + this.goodstable[i].seedcode + ',') == -1)
            seedcodes += this.goodstable[i].seedcode + ','
        }

        //取当前库存
        getGoodsListWithStoreDetail({
          seedcode: seedcodes,
          cangkucode: this.form.cangkucode,
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1, nolimit: '1', notransfernum: '1', nobuynum: '1'
        }).then(resStore => {//nodeliverying:'1',
          this.initWithStoredetail(resStore.data.obj);
        });
      },
      initWithStoredetail(storeData){
        var addstoretable = JSON.parse(JSON.stringify(this.storetable));
        this.storetable = []

        if (storeData) {
          for (var i in storeData) {
            var packagesize = JSON.parse(storeData[i].packagesize);
            var seedname = storeData[i].seedname;
            var costprice = 0;
            for (let j in this.goodstable) {
              if (this.goodstable[j].seedcode == storeData[i].seedcode) {
                seedname = this.goodstable[j].seedname;
                costprice = this.goodstable[j].costprice;
                break;
              }
            }

            var item = {
              "seedcode": storeData[i].seedcode,
              "seedname": seedname,
              "costprice": costprice,
              "deliverying": storeData[i].deliverying,
              "subtractnum":storeData[i].subtractnum,
              "tractnum": storeData[i].subtractnum - storeData[i].deliverying,//当前库存数量(待发货的不盘点)
              "M": packagesize.M,
              "C": packagesize.C,
              "excelitem": [],
              "P": 0//storeData[i].subtractnum//盘点数量
            };
            if (this.showKucun) {
              item.P = item.tractnum;
            }
            if (storeData[i].subtractnum != 0 || storeData[i].deliverying != 0)
              this.storetable.push(item)
          }
          if (this.showKucun) {
            for (let i in addstoretable) {
              var hasValue = false;
              for (let j in this.storetable) {
                if (this.storetable[j].seedcode == addstoretable[i].seedcode &&this.storetable[j].M == addstoretable[i].M && this.storetable[j].C == addstoretable[i].C) {
                  this.storetable[j].P += addstoretable[i].P;
                  hasValue = true;
                  break;
                }
              }
              if (!hasValue) {
                addstoretable[i].tractnum = 0;
                this.storetable.push(addstoretable[i])
              }
            }
          }
          this.sortTable();
        }
      }
    },
    components: {
      MakeInventoryFrameAdd
    },

    mounted() {
      this.enabledaddgoods=isUGO()||isXiaoTuan()||isDatao();
      this.onlySelectChild=!(isUGO()||isDatao());
    },
  }
</script>

<style scoped>
  .titlecolor {
    color: #20A0FF
  }

  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventoryFrameEdit.vue